import { render, staticRenderFns } from "./SaveLinkInstructions.vue?vue&type=template&id=17af7901&scoped=true&"
import script from "./SaveLinkInstructions.vue?vue&type=script&lang=js&"
export * from "./SaveLinkInstructions.vue?vue&type=script&lang=js&"
import style0 from "./SaveLinkInstructions.vue?vue&type=style&index=0&id=17af7901&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17af7901",
  null
  
)

export default component.exports